import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {materialDark} from 'react-syntax-highlighter/dist/esm/styles/prism'
import './Markdown.sass'

const renderers = {
    code: ({language, value}) => {
        return <SyntaxHighlighter style={materialDark} language={language} children={value} />
    }
}


const Markdown = (props) => (
    <div className={`markdown ${props.small?'markdown-small':''}`} style={props.style}>
        <ReactMarkdown plugins={[gfm]} renderers={renderers} children={props.children} />
    </div>
)
export default Markdown